export const headerStyles = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
};
export const headerOptions = {
    display: "grid",
    gridAutoFlow: "column",
    gap: "1rem",
};